import { merge as observableMerge } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UserService } from '../../shared';
import { ConfigService } from '../../shared/services/config.service';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { DepotLocation } from '../../models';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-adduser',
  templateUrl: './add.user.component.html',
  styleUrls: ['./add.user.component.css'],
  providers: [UserService],
  standalone: true,
  imports: [
    FormsModule,
    MatFormField,
    ReactiveFormsModule,
    MatLabel,
    MatInput,
    MatError,
    MatButton
  ]
})
export class AddUserComponent implements OnInit {
  user: any = {};
  locations: DepotLocation[] = [];
  newUserForm = new UntypedFormGroup({
    name: new UntypedFormControl('', Validators.required),
    user_name: new UntypedFormControl(''),
    email: new UntypedFormControl('', Validators.required),
    password: new UntypedFormControl('', Validators.required),
    password_confirmed: new UntypedFormControl('', Validators.required),
    default_location: new UntypedFormControl('')
  });

  constructor(
    private userService: UserService,
    private router: Router,
    private configService: ConfigService
  ) {}

  ngOnInit() {
    this.configService.locations.subscribe((locations) => {
      if (!locations) {
        return;
      }
      this.locations = locations;
    });
    observableMerge([
      this.newUserForm.controls['email'].valueChanges,
      this.newUserForm.controls['user_name'].valueChanges
    ]).subscribe((value) => {
      if (this.newUserForm.value.email || this.newUserForm.value.user_name) {
        this.newUserForm.controls['email'].setErrors(null);
        this.newUserForm.controls['user_name'].setErrors(null);
      }
    });
  }

  save() {
    const values = this.newUserForm.value;
    if (!values.email && !values.user_name) {
      this.newUserForm.controls['email'].setErrors({
        required: 'You must provide either an email or user name'
      });
      this.newUserForm.controls['user_name'].setErrors({
        required: 'You must provide either an email or user name'
      });
      return;
    }
    this.userService.create(this.newUserForm.value).subscribe(
      (response) => {
        this.backToList();
      },
      (error) => {
        if (error.status === 409 && error.error.message) {
          this.newUserForm.controls['email'].setErrors({
            conflict: error.error.message
          });
        }
      }
    );
  }

  backToList() {
    this.router.navigate(['users']);
  }
}
